/**
 * Maps Firebase Auth error codes to user-friendly messages.
 * Firebase errors have a `code` property like "auth/invalid-credential".
 */
const FIREBASE_AUTH_MESSAGES: Record<string, string> = {
  'auth/invalid-credential': 'Invalid email or password. Please try again.',
  'auth/invalid-email': 'Please enter a valid email address.',
  'auth/user-not-found': 'No account found with this email.',
  'auth/wrong-password': 'Incorrect password.',
  'auth/email-already-in-use': 'This email is already in use. Sign in or use another email.',
  'auth/weak-password': 'Password is too weak. Use at least 6 characters.',
  'auth/too-many-requests': 'Too many attempts. Please try again later.',
  'auth/network-request-failed': 'Network error. Check your connection and try again.',
  'auth/popup-closed-by-user': 'Sign-in was cancelled.',
  'auth/cancelled-popup-request': 'Sign-in was cancelled.',
  'auth/popup-blocked': 'Pop-up was blocked. Allow pop-ups for this site and try again.',
  'auth/operation-not-allowed': 'This sign-in method is not enabled. Contact support.',
  'auth/account-exists-with-different-credential':
    'An account already exists with this email using another sign-in method. Try that method instead.',
  'auth/credential-already-in-use': 'This sign-in method is already linked to another account.',
  'auth/requires-recent-login': 'Please sign out and sign in again to continue.',
  'auth/user-disabled': 'This account has been disabled. Contact support.',
  'auth/expired-action-code': 'This link has expired. Please request a new one.',
  'auth/invalid-action-code': 'This link is invalid or has already been used.',
};

export function getFriendlyAuthErrorMessage(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  if (error == null) return fallback;
  const code = (error as { code?: string }).code;
  if (code && typeof code === 'string' && FIREBASE_AUTH_MESSAGES[code]) {
    return FIREBASE_AUTH_MESSAGES[code];
  }
  if (error instanceof Error && error.message && !error.message.includes('Firebase:')) {
    return error.message;
  }
  return fallback;
}
